// Mails zuordnen (the Klärfälle of the prototype, renamed 01.11.2026): mails without a safe assignment. Every decision
// becomes an example for the AI (spec 7.5).
import { S } from "../state";
import { $, emptyState } from "../util";
import { mailCard } from "./mailcard";

export function renderKlaer(): void {
  const el = $("#v-klaerfaelle");
  if (!S.loaded) {
    el.innerHTML = emptyState("Lade Mails …", "");
    return;
  }
  const list = [...S.unclear].sort((a, b) => b.receivedAt.localeCompare(a.receivedAt));
  const intro = `<div class="brief-head"><span class="eyebrow">Zuordnen</span><h1>Mails zuordnen</h1><p>Bei diesen Mails ist die Pipeline nicht sicher, wohin sie gehören. Ordne sie einem Deal oder einer Anfrage zu oder sortiere sie aus.</p></div>`;
  el.innerHTML = list.length
    ? `${intro}<div class="klaer">${list.map((m) => mailCard(m, { allowAnfrage: true, allowUnklar: false })).join("")}</div>`
    : intro + emptyState("Alles zugeordnet", "Mails, bei denen die Pipeline nicht sicher ist, erscheinen hier.");
}
